// src/App.js
import React from 'react';
import {BrowserRouter as Router, Route, Routes} from 'react-router-dom';
import {Home} from './pages';
import './assets/css/reset.css';
import './assets/css/bootstrap-grid.css';
import './assets/css/www.css'
import 'select2';
import 'animate.css';
import {Analytics, MetaLoader, TitleLoader} from "./components";

function App() {
    return (
        <Router>
            <TitleLoader/>
            <MetaLoader/>
            <Analytics/>
            <Routes>
                <Route path="/" element={<Home/>}/>
            </Routes>
        </Router>
    );
}

export default App;
